import React, { useState } from 'react';
import { stickers } from '../styles/designTokens';
import './StickerSelector.css';

interface StickerSelectorProps {
  onStickerSelect: (sticker: string) => void;
  category?: 'emotions' | 'activities' | 'achievements';
  title?: string;
}

const StickerSelector: React.FC<StickerSelectorProps> = ({ 
  onStickerSelect, 
  category = 'emotions',
  title 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSticker, setSelectedSticker] = useState('');

  const handleStickerClick = (sticker: string) => {
    setSelectedSticker(sticker);
    onStickerSelect(sticker);
    setIsOpen(false);
  };

  const categoryTitles = {
    emotions: '😊 Настроение',
    activities: '💪 Активность', 
    achievements: '🏆 Достижение'
  };

  const categoryStickers = stickers[category];

  return (
    <div className="sticker-selector">
      <button 
        className="sticker-trigger hover-scale"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="sticker-icon">
          {selectedSticker || '😊'}
        </span>
        <span className="sticker-label">
          {title || categoryTitles[category]}
        </span>
        <span className={`sticker-arrow ${isOpen ? 'open' : ''}`}>
          ▼
        </span>
      </button>

      {isOpen && (
        <div className="sticker-dropdown animate-scale-in">
          <div className="sticker-grid">
            {categoryStickers.map((sticker, index) => (
              <button
                key={index}
                className={`sticker-option hover-lift ${
                  selectedSticker === sticker ? 'selected' : ''
                }`}
                onClick={() => handleStickerClick(sticker)}
                title={sticker}
              >
                <span className="sticker-emoji">{sticker}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StickerSelector;
